import { mediaUrl } from '../../utils/media';
import { useNavigate } from 'react-router-dom';

// ponytail: hidePrice=true => library mode (clean list, license badge); false => catalog card (price/badges)
export default function EbookCard({ ebook, hidePrice = false }) {
  const navigate = useNavigate();
  const cover = ebook.cover_url ? (
    <img
      src={mediaUrl(ebook.cover_url)}
      alt={ebook.title}
      className={`w-12 h-16 rounded object-cover flex-shrink-0 shadow-sm ${hidePrice ? 'md:w-14 md:h-[76px]' : ''}`}
    />
  ) : (
    <div className={`w-12 h-16 bg-wa-light rounded flex-shrink-0 ${hidePrice ? 'md:w-14 md:h-[76px]' : ''}`} />
  );

  // library mode: clean, professional list item
  if (hidePrice) {
    return (
      <div className="flex items-center gap-3 min-w-0">
        {cover}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-gray-800 text-sm font-semibold truncate">{ebook.title}</p>
            <svg className="w-4 h-4 text-green-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <p className="text-gray-400 text-xs truncate mt-0.5">
            {ebook.seller_name || 'Penjual'}
          </p>
          {ebook.license_code && (
            <div className="inline-flex items-center gap-1 mt-1.5">
              <span className="text-[10px] font-mono tracking-wider text-gray-500 bg-gray-100 border border-gray-200 px-1.5 py-px rounded">
                {ebook.license_code}
              </span>
            </div>
          )}
        </div>
        <svg className="w-4 h-4 text-gray-300 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    );
  }

  // catalog / home mode (original)
  return (
    <div className="flex gap-2 min-w-0">
      {cover}
      <div className="flex-1 min-w-0 overflow-hidden">
        <div className="flex gap-1 flex-wrap mb-1">
          {ebook.is_bestseller && (
            <span className="bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-0.5 rounded-full">🏆 Bestseller</span>
          )}
          {ebook.is_new && !ebook.is_bestseller && (
            <span className="bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">✨ Baru</span>
          )}
          {ebook.discount_pct > 0 && (
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">-{ebook.discount_pct}%</span>
          )}
        </div>

        <p className="text-gray-800 text-sm font-medium truncate">{ebook.title}</p>
        {ebook.tenant_owner_id
          ? <span className="text-gray-500 text-xs truncate cursor-pointer hover:underline" onClick={e => { e.stopPropagation(); navigate(`/seller/${ebook.tenant_owner_id}`); }}>{ebook.seller_name || 'Penjual'}</span>
          : <p className="text-gray-500 text-xs truncate">{ebook.seller_name || 'Penjual'}</p>
        }
        {ebook.license_code && (
          <p className="text-gray-400 text-[10px] font-mono truncate mt-0.5">
            Lisensi: {ebook.license_code}
          </p>
        )}

        {ebook.discount_pct > 0 ? (
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-wa-dark font-bold text-sm">
                Rp {Number(ebook.final_price || ebook.price).toLocaleString('id-ID')}
              </span>
              <span className="text-gray-400 line-through text-xs">
                Rp {Number(ebook.price).toLocaleString('id-ID')}
              </span>
            </div>
          ) : (
            <span className="text-wa-dark font-bold text-sm mt-0.5 block">
              {ebook.price === 0 ? 'Gratis' : `Rp ${Number(ebook.price).toLocaleString('id-ID')}`}
            </span>
          )}
      </div>
    </div>
  );
}